import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/hero-layer.png'
import _imports_1 from '@/assets/mockup-1.png'


const _hoisted_1 = {
  class: "mockup xyz-in",
  xyz: "fade"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "hero-bg-layer"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Locate any phone, anywhere",
  class: "xyz-in phone-mockup",
  xyz: "up fade duration-6 delay-3",
  style: {"--xyz-translate-y":"10%"}
}, null, -1)
const _hoisted_4 = {
  class: "alert xyz-nested text-center",
  xyz: "fade down small-5 delay-9 duration-4 ease-out-back"
}
const _hoisted_5 = { class: "text-primary mb-05" }
const _hoisted_6 = { class: "text-dark" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "pin xyz-in",
  xyz: "fade delay-10"
}, [
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_8 = {
  class: "button bg-primary btn xyz-in",
  xyz: "fade delay-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h6", _hoisted_5, _toDisplayString($setup.strings.home.main[18]), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString($setup.strings.home.main[20]), 1)
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, _toDisplayString($setup.strings.core['Locate']), 1)
  ]))
}